import { Link } from 'react-router-dom';
import { articleImageMap } from '@/mocks/article-images';

interface ArticleContentProps {
  title: string;
  slug: string;
  category: string;
  categoryName: string;
  date: string;
  readTime: number;
  content: string;
}

export default function ArticleContent({
  title,
  slug,
  category,
  categoryName,
  date,
  readTime,
  content,
}: ArticleContentProps) {
  const imageUrl = articleImageMap[slug] || '';

  const articleSchema = {
    '@context': 'https://schema.org',
    '@type': 'Article',
    headline: title,
    description: content.replace(/<[^>]*>/g, '').substring(0, 160),
    image: imageUrl,
    datePublished: date,
    dateModified: date,
    author: {
      '@type': 'Organization',
      name: '安全指南',
    },
    publisher: {
      '@type': 'Organization',
      name: '安全指南',
    },
    mainEntityOfPage: {
      '@type': 'WebPage',
      '@id': `https://yourdomain.com/article/${slug}`,
    },
  };

  return (
    <>
      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{ __html: JSON.stringify(articleSchema) }}
      />

      <article className="max-w-3xl mx-auto">
        <div className="mb-6">
          <Link
            to={`/category/${category}`}
            className="inline-flex items-center text-xs px-2.5 py-1 rounded-full bg-accent-100 text-accent-700 font-medium hover:bg-accent-200 transition-colors whitespace-nowrap cursor-pointer mb-4"
          >
            {categoryName}
          </Link>
          <h1 className="font-heading text-xl md:text-2xl lg:text-3xl font-bold text-foreground-950 leading-tight mb-4">
            {title}
          </h1>
          <div className="flex items-center gap-3 text-sm text-foreground-500">
            <span>{date}</span>
            <span>·</span>
            <span>{readTime} 分钟阅读</span>
          </div>
        </div>

        <div className="w-full aspect-video rounded-lg overflow-hidden mb-8">
          <img
            src={imageUrl}
            alt={title}
            title={`${title} - 安全指南`}
            className="w-full h-full object-cover"
          />
        </div>

        <div
          className="prose-sm md:prose-base max-w-none text-foreground-800 leading-relaxed article-content"
          dangerouslySetInnerHTML={{ __html: content }}
        />
      </article>
    </>
  );
}